<div class="report-prev-page">
  @if(movementsBlocked) {
  <div class="report-prev-alert report-prev-alert--error">
    <p-message severity="error" icon="pi pi-ban"
      [text]="'REPORTS.BANNER_MOVEMENTS_BLOCKED' | translate:{ periods: openPeriodsDisplay }" />
  </div>
  }
  @if(showBanner) {
  <div class="report-prev-alert report-prev-alert--warn">
    <p-message severity="warn" icon="pi pi-exclamation-triangle"
      [text]="'REPORT_PREV.BANNER_UNCLOSED' | translate:{ month: previousMonthName }" />
  </div>
  }
  @if(cambiosDetectados) {
  <div class="report-prev-alert report-prev-alert--error">
    <p-message severity="error" icon="pi pi-exclamation-triangle"
      [text]="'REPORT_PREV.BANNER_UNSAVED' | translate" />
  </div>
  }

  <header class="report-prev-hero">
    <div class="report-prev-hero__inner">
      <div class="report-prev-hero__brand">
        <div class="report-prev-hero__icon" aria-hidden="true">
          <i class="pi pi-file-edit"></i>
        </div>
        <div class="report-prev-hero__text">
          <span class="report-prev-hero__eyebrow">{{ 'REPORT_PREV.HERO_EYEBROW' | translate }}</span>
          <h1 class="report-prev-hero__title">{{ 'REPORT_PREV.TITLE' | translate }}</h1>
        </div>
      </div>
      <div class="report-prev-hero__meta" data-tour="report-actions">
        @if (cambiosDetectados) {
        <span class="report-prev-hero__chip report-prev-hero__chip--warn">
          <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
          {{ 'REPORT_PREV.STATUS_UNSAVED' | translate }}
        </span>
        }
        <p-button [label]="'REPORT_PREV.BTN_CLOSED_REPORTS' | translate" icon="pi pi-folder-open"
          styleClass="report-prev-hero__btn" routerLink="/dashboard/reports-old" />
        @if(!cambiosDetectados) {
        <p-button data-tour="report-view" [label]="'REPORT_PREV.BTN_VIEW_REPORT' | translate" icon="pi pi-eye"
          styleClass="report-prev-hero__btn" (click)="verInforme()" />
        }
        <p-button [label]="textBtn | translate" icon="pi pi-save" [loading]="saving"
          (click)="guardarPredefinidos()" styleClass="report-prev-hero__btn report-prev-hero__btn--cta" />
        @if (canViewLogs) {
        <p-button type="button" icon="pi pi-history" [label]="'REPORT_PREV.HISTORY_BUTTON' | translate"
          styleClass="report-prev-hero__btn" [pTooltip]="'REPORT_PREV.TOOLTIP_HISTORY' | translate"
          tooltipPosition="left" (onClick)="openHistorial()" />
        }
      </div>
    </div>
  </header>

  @if (openInformeMesAnio) {
  <div class="report-prev-period" role="region" [attr.aria-label]="'REPORT_PREV.OPEN_MONTH_HINT' | translate">
    <span class="report-prev-period__eyebrow">{{ 'REPORT_PREV.PERIOD_EYEBROW' | translate }}</span>
    <span class="report-prev-period__value notranslate">
      <i class="pi pi-calendar" aria-hidden="true"></i>
      {{ openInformeMesAnio }}
    </span>
  </div>
  }

  <div class="report-prev-layout">
    <div class="report-prev-col">
      <article class="report-prev-panel" data-tour="report-worker">
        <header class="report-prev-panel__head">
          <div class="report-prev-panel__icon report-prev-panel__icon--accent">
            <i class="pi pi-users"></i>
          </div>
          <div class="report-prev-panel__titles">
            <h2 class="report-prev-panel__title">{{ 'REPORT_PREV.TABLE_WORKER' | translate }}</h2>
          </div>
        </header>
        <div class="report-prev-panel__body report-prev-panel__body--flush">
          <p-table [value]="informeObreoOptions" styleClass="report-prev-table"
            [tableStyle]="{ 'min-width': '100%' }">
            <ng-template #header>
              <tr>
                <th>{{ 'REPORT_PREV.COL_DESC' | translate }}</th>
                <th class="text-center">{{ 'REPORT_PREV.COL_RESPONSE' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-product>
              <tr>
                <td>{{ getItemLabel(product.descripcion, product.codigo) }}</td>
                <td class="text-center">
                  <p-togglebutton [ngModel]="product.valor === '0'"
                    (ngModelChange)="onObreroToggle(product, $event)"
                    [onLabel]="'REPORT_PREV.YES_SHORT' | translate"
                    [offLabel]="'REPORT_PREV.NO_SHORT' | translate"
                    styleClass="report-prev-toggle notranslate" size="small" />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </article>

      <article class="report-prev-panel" data-tour="report-spiritual">
        <header class="report-prev-panel__head report-prev-panel__head--toolbar">
          <div class="report-prev-panel__icon report-prev-panel__icon--brand">
            <i class="pi pi-heart"></i>
          </div>
          <div class="report-prev-panel__titles">
            <h2 class="report-prev-panel__title">{{ 'REPORT_PREV.TABLE_SPIRITUAL' | translate }}</h2>
          </div>
          <div class="report-prev-mode">
            <span class="report-prev-mode__label"
              [class.report-prev-mode__label--auto]="checkedEspiritual"
              [class.report-prev-mode__label--manual]="!checkedEspiritual">
              {{ (checkedEspiritual ? 'REPORT_PREV.MODE_AUTO' : 'REPORT_PREV.MODE_MANUAL') | translate }}
            </span>
            <p-toggleswitch [(ngModel)]="checkedEspiritual" (ngModelChange)="llenarDesdeDoc($event)">
              <ng-template #handle let-checked="checked">
                <i [ngClass]="['pi', checked ? 'pi-check' : 'pi-pencil']"></i>
              </ng-template>
            </p-toggleswitch>
          </div>
        </header>
        <div class="report-prev-panel__body report-prev-panel__body--flush">
          <p-table [value]="informeEspiritualOptions" styleClass="report-prev-table"
            [tableStyle]="{ 'min-width': '100%' }">
            <ng-template #header>
              <tr>
                <th>{{ 'REPORT_PREV.COL_DESC' | translate }}</th>
                <th class="text-end">{{ 'REPORT_PREV.COL_RESPONSE' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-product>
              <tr>
                <td>{{ getItemLabel(product.descripcion, product.codigo) }}</td>
                <td class="text-end">
                  <p-inputNumber [(ngModel)]="product.valor" name="monto" placeholder="0"
                    styleClass="report-prev-input-num" [inputStyle]="{ 'text-align': 'right' }" />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </article>
    </div>

    <div class="report-prev-col">
      <article class="report-prev-panel" data-tour="report-b2">
        <header class="report-prev-panel__head">
          <div class="report-prev-panel__icon report-prev-panel__icon--finance">
            <i class="pi pi-wallet"></i>
          </div>
          <div class="report-prev-panel__titles">
            <h2 class="report-prev-panel__title">{{ 'REPORT_PREV.TABLE_EXPENSE_B2' | translate }}</h2>
          </div>
        </header>
        <div class="report-prev-panel__body report-prev-panel__body--flush">
          <p-table [value]="informeFinancieroEgresosB2Options" styleClass="report-prev-table"
            [tableStyle]="{ 'min-width': '100%' }">
            <ng-template #header>
              <tr>
                <th>{{ 'REPORT_PREV.COL_DESC' | translate }}</th>
                <th class="text-end">{{ 'REPORT_PREV.COL_AMOUNT' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-product>
              <tr>
                <td>{{ getItemLabel(product.descripcion, product.codigo) }}</td>
                <td class="text-end">
                  <p-inputNumber [(ngModel)]="product.valor" name="monto" mode="currency"
                    [currency]="currencyCode" [locale]="currencyLocale" size="small" placeholder="0,00"
                    styleClass="report-prev-input-num"
                    [readonly]="product.esLecturaSolo || product.codigo === 'EG-B2-13'"
                    [inputStyle]="{ 'text-align': 'right' }" />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </article>

      <article class="report-prev-panel" data-tour="report-observations">
        <header class="report-prev-panel__head">
          <div class="report-prev-panel__icon report-prev-panel__icon--accent">
            <i class="pi pi-comment"></i>
          </div>
          <div class="report-prev-panel__titles">
            <h2 class="report-prev-panel__title">{{ 'REPORT_PREV.OBS_TITLE' | translate }}</h2>
          </div>
        </header>
        <div class="report-prev-panel__body">
          <textarea rows="7" pTextarea [autoResize]="false" [(ngModel)]="observaciones"
            class="report-prev-textarea w-100"></textarea>
        </div>
      </article>
    </div>
  </div>
</div>

<p-toast></p-toast>

<p-dialog [(visible)]="monthDialog" [header]="'REPORT_PREV.DIALOG_PERIOD_TITLE' | translate" [modal]="true"
  [draggable]="false" [dismissableMask]="true" styleClass="report-prev-dialog report-prev-dialog--period"
  [style]="{ width: 'min(420px, 92vw)' }">
  <div class="report-prev-dialog__body">
    <p-floatlabel variant="on">
      <p-datepicker inputId="monthPicker" [(ngModel)]="selectedMonth" view="month" dateFormat="mm/yy" showIcon
        [readonlyInput]="true" iconDisplay="input" [appendTo]="'body'" styleClass="w-100" />
      <label for="monthPicker">{{ 'REPORT_PREV.FIELD_MONTH_YEAR' | translate }}</label>
    </p-floatlabel>
  </div>
  <ng-template pTemplate="footer">
    <div class="report-prev-dialog__footer">
      <p-button [label]="'COMMON.CANCEL' | translate" severity="secondary" (onClick)="monthDialog = false"
        styleClass="report-prev-btn report-prev-btn--ghost notranslate" />
      <p-button [label]="'FINANCE.CONSULT' | translate" icon="pi pi-search" [disabled]="!selectedMonth"
        (onClick)="consultarInformesAnteriores()"
        styleClass="report-prev-btn report-prev-btn--primary notranslate" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="historialDialogVisible" [modal]="true" [draggable]="false" [dismissableMask]="true"
  [style]="{ width: 'min(560px, 92vw)' }" [focusOnShow]="false" styleClass="report-prev-dialog report-prev-historial-dialog"
  (onHide)="closeHistorial()">
  <ng-template pTemplate="header">
    <div class="report-prev-historial-header">
      <span class="report-prev-historial-header__icon"><i class="pi pi-history"></i></span>
      <div class="report-prev-historial-header__text">
        <span class="report-prev-historial-header__title">{{ 'REPORT_PREV.HISTORY_DIALOG_TITLE' | translate }}</span>
        <span class="report-prev-historial-header__subtitle">{{ 'REPORT_PREV.TITLE' | translate }}</span>
      </div>
    </div>
  </ng-template>

  <div class="report-prev-historial-meta">
    <div class="report-prev-historial-meta__item">
      <span class="report-prev-historial-meta__label">{{ 'REPORT_PREV.HISTORY_CREATED_BY' | translate }}</span>
      <span class="report-prev-historial-meta__value">{{ historialCreatedByName }}</span>
    </div>
    <div class="report-prev-historial-meta__item">
      <span class="report-prev-historial-meta__label">{{ 'REPORT_PREV.HISTORY_UPDATED_BY' | translate }}</span>
      <span class="report-prev-historial-meta__value">{{ historialUpdatedByName }}</span>
    </div>
  </div>

  @if (historialEntries.length > 0) {
  <ul class="report-prev-historial-timeline">
    @for (entry of visibleHistorialEntries; track $index) {
    <li class="report-prev-historial-item"
      [class.report-prev-historial-item--create]="entry.action === 'create'"
      [class.report-prev-historial-item--update]="entry.action === 'update'">
      <span class="report-prev-historial-item__dot">
        <i class="pi" [ngClass]="entry.action === 'create' ? 'pi-plus' : 'pi-pencil'"></i>
      </span>
      <div class="report-prev-historial-item__content">
        <div class="report-prev-historial-item__top">
          <span class="report-prev-historial-item__action">
            {{ (entry.action === 'create' ? 'REPORT_PREV.HISTORY_ACTION_CREATE' : 'REPORT_PREV.HISTORY_ACTION_UPDATE') | translate }}
          </span>
          <span class="report-prev-historial-item__date">{{ entry.fecha }}</span>
        </div>
        <div class="report-prev-historial-item__author">
          <i class="pi pi-user"></i> {{ entry.byName }}
        </div>
        @if (entry.resumen) {
        <div class="report-prev-historial-item__resumen">{{ entry.resumen }}</div>
        } @else if (entry.campos?.length) {
        <div class="report-prev-historial-item__campos">
          @for (campo of entry.campos; track campo) {
          <span class="report-prev-historial-chip">{{ campo }}</span>
          }
        </div>
        }
      </div>
    </li>
    }
  </ul>
  @if (hasMoreHistorialEntries) {
  <div class="historial-load-more">
    <span class="historial-showing text-muted small">
      {{ 'COMMON.HISTORY_SHOWING' | translate:{ visible: historialVisibleCount, total: historialEntries.length } }}
    </span>
    <p-button [label]="'COMMON.HISTORY_LOAD_MORE' | translate" icon="pi pi-chevron-down"
      severity="secondary" styleClass="p-button-text p-button-sm" (onClick)="loadMoreHistorial()"></p-button>
  </div>
  }
  } @else {
  <div class="report-prev-historial-empty">
    <i class="pi pi-inbox"></i>
    <span>{{ 'REPORT_PREV.HISTORY_EMPTY' | translate }}</span>
  </div>
  }

  <ng-template pTemplate="footer">
    <p-button [label]="'COMMON.CLOSE' | translate" icon="pi pi-times" severity="secondary"
      styleClass="report-prev-btn report-prev-btn--ghost" (onClick)="closeHistorial()" />
  </ng-template>
</p-dialog>
